import {
  startLearnerRun,
  getLearnerExamOverview,
  getLearnerQuestions,
  submitLearnerExam,
  getLearnerSubmissionDetail,
  getPublicQuestions,
  submitPublicExam,
  getTestRunDetail,
  getExamRanking,
  getSubmissionDetail
} from "@/api/kuizy"

export function createPublicProvider({ orgId, runId, preview = false }) {
  return {
    kind: "public",
    async ensureRun() { return { orgId, runId } },
    async getQuestions() {
      const { data } = await getPublicQuestions({ org_id: orgId, run_id: runId, preview: preview ? 1 : 0 })
      return data
    },
    async submit({ answers, spend_sec, nick }) {
      const { data } = await submitPublicExam({
        org_id: orgId, test_run_id: runId, nick_name: nick || "", spend_sec, answers, preview: !!preview
      })
      return data
    },
    async getOverview() {
      const { data } = await getTestRunDetail({ org_id: orgId, run_id: runId })
      return data
    },
    async getRanking() {
      const { data } = await getExamRanking({ org_id: orgId, test_run_id: runId })
      return data || []
    },
    async getSubmissionDetail(submissionId) {
      if (!submissionId) return null
      const { data } = await getSubmissionDetail(orgId, submissionId)
      return data
    },
    getRunId() { return runId }
  }
}

export function createLearnerProvider({ orgId, runId, courseId, testId }) {
  let cachedRunId = runId || null
  return {
    kind: "learner",
    async ensureRun() {
      if (!cachedRunId) {
        const { data } = await startLearnerRun({ course_id: courseId, test_id: testId })
        cachedRunId = data?.run_id || data?.id || data?.test_run_id
      }
      return { orgId, runId: cachedRunId, courseId, testId }
    },
    async getQuestions() {
      const { runId: rid } = await this.ensureRun()
      const { data } = await getLearnerQuestions({ run_id: rid })
      return data
    },
    async submit({ answers, spend_sec }) {
      const { runId: rid } = await this.ensureRun()
      const { data } = await submitLearnerExam({ run_id: rid, spend_sec, answers })
      try { sessionStorage.setItem(`kuizy_last_submission_${rid}`, data?.submission_id || "") } catch {}
      return data
    },
    async getOverview() {
      const { runId: rid } = await this.ensureRun()
      const { data } = await getLearnerExamOverview({ run_id: rid })
      return data || {}
    },
    async getRanking() {
      const { runId: rid } = await this.ensureRun()
      const { data } = await getExamRanking({ test_run_id: rid })
      return data || []
    },
    async getSubmissionDetail(submissionId) {
      if (!submissionId) return null
      const { data } = await getLearnerSubmissionDetail(submissionId)
      return data
    },
    getRunId() { return cachedRunId }
  }
}
